import { Alert, Box, Link, Text } from '@nimbus-ds/components';
import { Page } from '@nimbus-ds/patterns';
import Country from '@tiendanube/common/src/enums/Country';
import { useNavegate } from 'App/hooks';
import { useResponsive } from 'commons/components';
import useGetCountry from 'domains/Auth/hooks/useGetCountry';
import { trackingOrdersAutoCancelNPActiveClick } from 'domains/Orders/tracking';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import nuvemPagoLogo from './nuvempago-logo.svg';
import autoCancelPNImg from './orders-auto-cancel-pagonube.png';
import autoCancelImg from './orders-auto-cancel.png';
import pagoNubeLogo from './pagonube-logo.svg';
import './OrdersAutoCancelPageHeader.scss';

interface OrdersAutoCancelPageHeaderProps {
  isNuvemPagoActive: boolean;
  hasPreviousConfig: boolean;
}

function OrdersAutoCancelPageHeader({
  isNuvemPagoActive = true,
  hasPreviousConfig = false,
}: Readonly<OrdersAutoCancelPageHeaderProps>): JSX.Element {
  const t = useTranslationOrders('autoCancel');
  const { goTo } = useNavegate();

  const { isMobile } = useResponsive();
  const country = useGetCountry();

  const alertNuvemPagoActiveWithoutPreviousConfig = (
    <Alert appearance="neutral">
      <Text color="neutral-textLow">{t('alertInfo')}</Text>
    </Alert>
  );

  const onActiveNPClick = () => {
    trackingOrdersAutoCancelNPActiveClick();
    goTo('/settings/payments');
  };

  const alertNuvemPagoInactiveWithPreviousConfig = (
    <Alert appearance="warning" title={t('alertNuvemPagoInactive.title')}>
      <Text color="neutral-textLow">
        {t('alertNuvemPagoInactive.subtitle')}
      </Text>
      <Link as="a" onClick={onActiveNPClick}>
        {t('reactivate')}
      </Link>
    </Alert>
  );

  return (
    <Page.Header
      title={t('title')}
      subtitle={t('description')}
      paddingX={isMobile ? 'none' : '6'}
    >
      {isNuvemPagoActive ? (
        alertNuvemPagoActiveWithoutPreviousConfig
      ) : !isNuvemPagoActive && hasPreviousConfig ? (
        alertNuvemPagoInactiveWithPreviousConfig
      ) : (
        <Box
          display="flex"
          flexDirection="row"
          gap="4"
          alignItems="center"
          padding="4"
          backgroundColor={isMobile ? 'neutral-surface' : 'neutral-background'}
          borderRadius="4"
        >
          <img
            src={country === Country.BR ? autoCancelImg : autoCancelPNImg}
            alt="Auto cancel orders illustration"
            width="90px"
            height="96px"
          />
          <Box
            display="flex"
            flex="1 0 0"
            flexDirection="column"
            gap="2"
            alignSelf="stretch"
            alignItems="flex-start"
          >
            <img
              src={country === Country.BR ? nuvemPagoLogo : pagoNubeLogo}
              alt={t('nuvemPagoLogoAlt')}
              width={country === Country.BR ? '96px' : '88px'}
              height="16px"
            />
            <Text color="neutral-textHigh">
              <span className="stratus--font-semibold">
                {t('bannerDescriptionBold')}
              </span>
              {t('bannerDescription')}
            </Text>
            <Link
              as="a"
              textDecoration="none"
              appearance="primary"
              onClick={onActiveNPClick}
            >
              {t('activateNow')}
            </Link>
          </Box>
        </Box>
      )}
    </Page.Header>
  );
}

export default OrdersAutoCancelPageHeader;
